import { EncryptionService } from './shared/services/encryption.service';
import { CommonApiService } from 'src/app/shared/services/commons-api.service';
import { FormsModule } from '@angular/forms';
import { DealerService } from './shared/services/dealer.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { LocalStorageModule } from 'angular-2-local-storage';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AppRoutingModule } from './app-routing.module';
import { localStorageServiceConfig } from './app.local-storage';
import { appReducer } from './shared/store/root.reducer';
import { AuthService } from './shared/services/auth.service';
import { ClaimsService } from './shared/services/claims.service';
import { AppComponent } from './app.component';
import { NavigationComponent } from './layout/navigation/navigation.component';
import { FooterComponent } from './layout/footer/footer.component';
import { TopComponent } from './layout/top/top.component';
import { DevLoginComponent } from './login/dev-login/dev-login.component';
import { LoginComponent } from './login/login/login.component';
import { AuthorizeDirective } from './shared/directives/authorize.directive';
import { UnauthorizeDirective } from './shared/directives/unauthorize.directive';
import { StagingLoginComponent } from './login/staging-login/staging-login.component';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HeaderComponent } from './layout/header/header.component';
import { AppNavigationComponent } from './layout/app-navigation/app-navigation.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { VersionService } from './shared/services/version.service';
import { ExternalLoginComponent } from './login/external-login/external-login.component';
import { SmartSearchSliderComponent } from './layout/navigation/smart-search/smart-search-slider.component';
import { HeaderBreadcrumbComponent } from './layout/header/header-breadcrumb/header-breadcrumb.component';
import { BreadcrumbService } from './shared/services/breadcrumb.service';
import { AppSettingsService } from './shared/services/app-settings.service';
import { environment } from 'src/environments/environment';
import { HeaderInterceptor } from './shared/interceptors/header-interceptor';
import { ResponseInterceptor } from './shared/interceptors/response-interceptor';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { OpsFeatures } from './ops-features';
import { CustomErrorHandler } from './shared/helpers/custom-error-handler.helper';
import { PendingCarouselComponent } from './layout/navigation/pending-carousel/pending-carousel.component';
import { NavigationItemComponent } from './layout/navigation/navigation-item/navigation-item.component';
import { OrdersService } from './shared/services/orders.service';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { InvoiceService } from './shared/services/invoice.service';
import { EffectsModule } from '@ngrx/effects';
import { effects } from 'src/app/shared/store/effects/index';
import { OpsLibModule } from 'ops-lib';
import { PagenotfoundComponent } from './layout/pagenotfound/pagenotfound.component';
import { PageNotFoundGuard } from 'src/app/shared/guards/page-not-found-guard.service';
import { LoginGuard } from 'src/app/shared/guards/login-guard.service';
import { RequestMakerHelpers } from 'src/app/shared/helpers/request-maker.helper';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { ClientidLoginComponent } from './login/clientid-login/clientid-login.component';
import {initConfiguration, OecIntegrationConfigurationService} from './shared/services/oec-integration-configuration-service.service';
import { EnvironmentLoader } from 'src/environments/utils/environment-loader.util';

export function loadEnvironmentFactory() {
  return () => EnvironmentLoader.loadEnvironment();
}

@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    FooterComponent,
    TopComponent,
    DevLoginComponent,
    LoginComponent,
    LoginComponent,
    AuthorizeDirective,
    UnauthorizeDirective,
    StagingLoginComponent,
    HeaderComponent,
    AppNavigationComponent,
    ExternalLoginComponent,
    SmartSearchSliderComponent,
    HeaderBreadcrumbComponent,
    PendingCarouselComponent,
    NavigationItemComponent,
    PagenotfoundComponent,
    ClientidLoginComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    OpsLibModule,
    FormsModule,
    AppRoutingModule,
    LocalStorageModule.withConfig(localStorageServiceConfig),
    StoreModule.forRoot(appReducer, {
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false
      }
    }),
    StoreRouterConnectingModule.forRoot(),
    EffectsModule.forRoot(effects),
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    PerfectScrollbarModule,
  ],
  providers: [
    AuthService,
    ClaimsService,
    OrdersService,
    InvoiceService,
    { provide: ErrorHandler, useClass: CustomErrorHandler },
    { provide: APP_INITIALIZER, useFactory: loadEnvironmentFactory, multi: true },
    DealerService,
    VersionService,
    CommonApiService,
    BreadcrumbService,
    AppSettingsService,
    OpsFeatures,
    { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true },
    [{ provide: LocationStrategy, useClass: HashLocationStrategy }],
    PageNotFoundGuard,
    LoginGuard,
    EncryptionService,
    RequestMakerHelpers,
    OecIntegrationConfigurationService,
    {
      provide: APP_INITIALIZER,
      useFactory: initConfiguration,
      deps: [OecIntegrationConfigurationService],
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
